import { ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * @param validator Original validator function
 * @param projection Projection function
 *
 * @returns
 * A validator function from a given `validator`
 * that performs the given `projection` on the
 * errors returned by the given `validator`.
 */
export function transformValidationErrors(
  validator: ValidatorFn,
  projection: (errors: ValidationErrors) => ValidationErrors,
): ValidatorFn;

export function transformValidationErrors<
  T extends ValidationErrors,
  V extends ValidationErrors,
>(validator: ValidatorFn, projection: (errors: T) => V): ValidatorFn;

export function transformValidationErrors<T extends ValidationErrors>(
  validator: ValidatorFn,
  projection: (errors: T) => T,
): ValidatorFn;

export function transformValidationErrors(
  validator: ValidatorFn,
  projection: (errors: ValidationErrors) => ValidationErrors,
): ValidatorFn {
  return (control) => {
    const result = validator(control);
    return result === null ? null : projection(result);
  };
}
